module.exports = __webpack_public_path__ + "img/add-image6.32f744ff.png";